export default {
  getBaseUrl() {
    return (document.querySelector("base") || {}).href || document.location.host;
  },
  getFrontendUrl() {
    let baseUrl = this.getBaseUrl();
    if (baseUrl && baseUrl[baseUrl.length - 1] !== "/") baseUrl += "/";
    if (baseUrl && !baseUrl.startsWith(window.location.protocol)) baseUrl = window.location.protocol + "//" + baseUrl;
    return baseUrl;
  }
};
